import { Component, Vue } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import WithRender from './groceryCheckOut.html';
import config from '@/settings/config.js';
import { LocalStorageService } from '@/services/LocalStorageService';
import { IInitiatePaymentResponseDto } from '@/Dtos/InitiatePaymentResponseDto';
import _axios from '@/services/axios';

interface IGroceryModel {
  key: string;
  description: string;
  totalAmount: number;
  salesCurrencyAmount: number;
  reference: string;
  collectorName: string;
  collectorSurname: string;
  collectorNumber: string;
  portiFolio: string;
  itemName: string;
}

@WithRender
@Component({
  components: {
    Loading
  }
})
export default class GroceryCheckOut extends Vue {
  isLoading = false;
  fullPage = true;
  paymentMethod = 'wallet';
  groceryModel: IGroceryModel = {} as IGroceryModel;
  payment: IInitiatePaymentResponseDto = {} as IInitiatePaymentResponseDto;
  localStorageService: LocalStorageService;
  showPaymentMethods = !config.isMobile;

  constructor() {
    super();
    this.localStorageService = new LocalStorageService();
    const grocery = this.localStorageService.get('grocery');
    if (grocery === null || grocery === '')
      this.$router.push('grocery');
    this.groceryModel = JSON.parse(grocery);
  }

  GetPaymentURL() {
    if (this.payment == null) return;
    return this.payment.payfasturl + this.paymentMethod;
  }

  initiatePayment() {
    if (this.paymentMethod === 'wallet')
      this.initiatePaymentDto.signingParty = 'wallet';
    else
      this.initiatePaymentDto.signingParty = 'payfast';

    this.isLoading = true;

    _axios.post(config.gateway + 'payment/Payment/InitiateGenericPayment', this.initiatePaymentDto)
      .then(response => {
        this.loadInitiatePaymentResponse(response.data);
      })
      .then(() => this.submitForPayment())
      .catch(err => { console.error(err); })
      .finally(() => this.isLoading = false);
  }

  get initiatePaymentDto() {
    return {
      itemName: this.groceryModel.itemName,
      rateKey: this.groceryModel.key,
      itemDescription: this.groceryModel.description,
      portfolio: this.groceryModel.portiFolio,
      recepientMobile: this.groceryModel.collectorNumber,
      senderMobile: '',
      signingParty: '',
      salesCurrencyAmount: this.groceryModel.salesCurrencyAmount,
      extra1: this.groceryModel.reference,
      extra2: JSON.stringify({
        CollectorName: this.groceryModel.collectorName,
        CollectorSurname: this.groceryModel.collectorSurname
      })
    };
  }

  private loadInitiatePaymentResponse(value: IInitiatePaymentResponseDto): void {
    this.localStorageService.add('paymentDetails', JSON.stringify(value));
    this.payment = value;
  }

  private submitForPayment(): void {
    if (this.paymentMethod === 'wallet')
      this.$router.push('Wallet');
    else
      (<HTMLFormElement>document.querySelector('#payfast')).submit();
  }
}
